<template>
  <div class="c-pageRoute">
    <div class="font_back c-pageRoute--btn">
      <p v-if="index > 1" @click="infoRouteTo(index-1)">
        <span>{{ text.prev }}</span>
        <span>{{items[index - 1].title}}</span>
      </p>
    </div>
    <div class="font_back c-pageRoute--btn">
      <p v-if="(parseInt(index)+1) < items.length" @click="infoRouteTo(index+1)">
        <span>{{ text.next }}</span>
        <span>{{items[index + 1].title}}</span>
      </p>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'productPageRoute',
    props: ['index'],
    data(){
      return{
        text:{
          prev: this.$t('common.prev_product'),
          next: this.$t('common.next_product')
        },
        items:[
          {title: this.$t('product_1.banner.title')},
          {title: this.$t('product_2.banner.title')},
          {title: this.$t('product_3.banner.title')},
          {title: this.$t('product_4.banner.title')},
          {title: this.$t('product_5.banner.title')},
          {title: this.$t('product_6.banner.title')}
        ]
      }
    },
    computed: {

    },
    methods:{
      infoRouteTo(index) {
        let page = index + 1
        let link = "product_" + page
        this.$router.push({
          name: link
        })
      }
    },
    created(){

    }
  }
</script>

<style>


</style>
